class Current {
  get user() {
    const currentUserId = this.#extractContentFromMetaTag("current-user-id")

    if (currentUserId) {
      return {
        id: Number.parseInt(currentUserId),
        name: this.#extractContentFromMetaTag("current-user-name"),
        timeZone: this.#extractContentFromMetaTag("current-user-time-zone")
      }
    } else {
      return null
    }
  }

  get room() {
    const currentRoomId = this.#extractContentFromMetaTag("current-room-id")

    if (currentRoomId) {
      return { id: Number.parseInt(currentRoomId) }
    } else {
      return null
    }
  }

  #extractContentFromMetaTag(name) {
    return document.querySelector(`meta[name="${name}"]`)?.getAttribute("content")
  }
}

globalThis.Current = new Current()
